import { BaseEntity } from "./BaseEntity";

export class TimesheetType extends BaseEntity {
    public name: string = "";
    public isCountable: boolean = false;

    constructor(model: Partial<TimesheetType> = {}) {
        super(model?.id);
        Object.assign(this, model);
    }
}

export type PTimesheetType = Partial<TimesheetType>;
